import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { getTranslationKeyForDay } from '@/domain/navigation/benachrichtigungen/components/details/shared/getTranslationKeyForDay';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';
import { mapMarkierung } from '@/domain/navigation/benachrichtigungen/utils/mapMarkierung';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

type StyleProps = CSSProperties & {
  '--dot-color': CSSProperties['color'];
};

export default function SchichttauschDetail({
  benachrichtigung,
}: {
  benachrichtigung: SchichttauschAntrag;
}) {
  const { t } = useTranslation();

  return (
    <DetailWrapper
      mitarbeiter={benachrichtigung.mitarbeiter}
      content={
        <div className="rounded-md p-2 border border-neutrals-N300 flex gap-1 items-baseline">
          <FontAwesomeIcon
            icon={faCircle}
            className="max-w-2.5 max-h-2.5 text-[var(--dot-color)]"
            style={
              {
                '--dot-color':
                  mapMarkierung[
                    benachrichtigung.schicht.arbeitsbereich.markierung
                  ].base,
              } as StyleProps
            }
          />
          <div className="text-xs">
            <div>{`${t(
              getTranslationKeyForDay(benachrichtigung.schicht.beginn.day()),
            )}., ${benachrichtigung.schicht.beginn.format('DD.MM.YYYY')}`}</div>
            <div className="text-neutrals-N700">{`${benachrichtigung.schicht.beginn.format(
              'HH:mm',
            )} – ${benachrichtigung.schicht.ende.format('HH:mm')} Uhr`}</div>
          </div>
        </div>
      }
    />
  );
}
